import {PIXI} from '@colonist/pixi'
import {UIGameAchievementConfettiItem, UIGameAchievementConfettiItemOptions} from './UIGameAchievementConfettiItem'

const INITIAL_QUEUE_COUNT = 1000

export class UIGameAchievementConfetti extends PIXI.Container {
    private readonly queue: UIGameAchievementConfettiItem[] = []

    constructor() {
        super()
        for(let i = 0; i < INITIAL_QUEUE_COUNT; i += 1) {
            const sprite = new UIGameAchievementConfettiItem()
            this.queue.push(sprite)
        }
    }

    launch(options: UIGameAchievementConfettiItemOptions) {
        for(let i = 0; i < options.count; i += 1) {
            if(this.queue.length !== 0) {
                const confetti = this.addChild(this.queue.pop() as PIXI.DisplayObject) as UIGameAchievementConfettiItem
                confetti.reset(options)
            } else {
                this.addChild(new UIGameAchievementConfettiItem(options))
            }
        }
    }

    update(deltaTime: number, elapsedMS: number) {
        for(let i = this.children.length - 1; i >= 0; i--) {
            if((this.children[i] as UIGameAchievementConfettiItem).update(deltaTime, elapsedMS)) this.children.splice(i, 1)
        }
    }

    afterFade() {
        this.removeChildren()
        this.alpha = 1
    }
}
